var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowArcLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.5001C14.5 11.6327 14.4473 11.7599 14.3536 11.8537C14.2598 11.9474 14.1326 12.0001 14 12.0001C13.8674 12.0001 13.7402 11.9474 13.6464 11.8537C13.5527 11.7599 13.5 11.6327 13.5 11.5001C13.4999 10.4124 13.1772 9.34918 12.5729 8.44483C11.9685 7.54049 11.1096 6.83564 10.1047 6.41941C9.09976 6.00319 7.994 5.89427 6.92719 6.10643C5.86038 6.3186 4.88044 6.84231 4.11125 7.61136L2.7125 9.00011H5.5C5.63261 9.00011 5.75979 9.05279 5.85355 9.14656C5.94732 9.24033 6 9.36751 6 9.50011C6 9.63272 5.94732 9.7599 5.85355 9.85367C5.75979 9.94744 5.63261 10.0001 5.5 10.0001H1.5C1.36739 10.0001 1.24021 9.94744 1.14645 9.85367C1.05268 9.7599 1 9.63272 1 9.50011V5.50011C1 5.36751 1.05268 5.24033 1.14645 5.14656C1.24021 5.05279 1.36739 5.00011 1.5 5.00011C1.63261 5.00011 1.75979 5.05279 1.85355 5.14656C1.94732 5.24033 2 5.36751 2 5.50011V8.29824L3.405 6.90262C4.31418 5.9939 5.47239 5.37517 6.73318 5.12465C7.99398 4.87412 9.30075 5.00305 10.4883 5.49513C11.6758 5.98721 12.6908 6.82035 13.4048 7.88922C14.1189 8.95808 14.5 10.2147 14.5 11.5001Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowArcLeft);
export default __webpack_public_path__ + "static/media/ArrowArcLeft.560fbe2f8eadb5ccdf22d4b8975716ee.svg";
export { ForwardRef as ReactComponent };